export const KeyCodeConstants = {
  ENTER: 13,
  SPACE_BAR: 32,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
};
